// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_64-7";
export var adjustableWidthBorderHeld = "_64-8";
export var arrow = "_64-3";
export var arrowButton = "_64-4";
export var headerCell = "_64-0";
export var help = "_64-2";
export var icon = "_64-1";
export var iconWrapper = "_64-6";
export var noBorder = "_64-b";
export var nonAdjustableWidthBorder = "_64-9";
export var nonAdjustableWidthBorderHeld = "_64-a";
export var textButton = "_64-5";